import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';

const DatePicker = ({ className, ...props }: any) => (
  <ReactDatePicker className={className} {...props} />
);

// interface JPUDatePickerProps {
//   width: string;
// }

export const JPUDatePicker = styled(DatePicker)`
  width: ${({ width }) => width || undefined};
  padding: 8px 12px;
  margin-bottom: 4px;
  border: none;
  color: ${({ theme }) => theme.colors.black};
  cursor: default;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  font-family: inherit;

  &&::placeholder {
    color: ${({ theme }) => theme.colors.black};
    font-family: inherit;
    opacity: 1;
  }

  &:hover::placeholder {
    color: ${({ theme }) => theme.colors.purple};
  }

  &.jpu-date-selected {
    background: ${({ theme }) => theme.colors.purple};
    color: ${({ theme }) => theme.colors.white};

    &&::placeholder {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const JPUDatePickerCalendarContainer = styled('div')`
  .react-datepicker__month-container {
    width: 100%;
  }
`;
